// extracted by mini-css-extract-plugin
export default {"editBlock":"statusProfile_editBlock__2XxE5"};